exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-a783af6e]{border:none;padding:6px 12px;border-radius:5px}.badge span[data-v-a783af6e]{background-color:transparent;font-size:.9rem;font-weight:600}.badge[data-v-a783af6e],span[data-v-a783af6e]{cursor:text}.badge-success[data-v-a783af6e]{color:#235c23;background-color:rgba(69,180,69,.507)}.badge-danger[data-v-a783af6e]{color:#be1e1e;background-color:rgba(190,30,30,.404)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a783af6e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Common/Badge/Badge.vue
// module id = 176
// module chunks = 0